import React, { Fragment, useEffect, useState } from "react";
import "./UserProfile.css";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";

import { accountPageData } from "./accountPageData";
// import MetaData from '../../layout/MetaData';
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, Outlet } from "react-router-dom";
import PaymentsIcon from '@mui/icons-material/Payments';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import PowerSettingsNewOutlined from "@mui/icons-material/PowerSettingsNewOutlined";
import AllAddresses from "../addressPages/AllAddresses";
import Loader from "../../layout/Loader/Loader";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ProfileDetails from "../Profile/ProfileDetails";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import InventoryIcon from '@mui/icons-material/Inventory';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import axios from "axios";
import { getCurrentUser } from "../../../redux/actions/userAction";



function UserProfile() {
  const currentUser = useSelector((state) => state.currentUser);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Assuming 768px as the mobile breakpoint


  // const [click, setClick] = useState(false);
  // const [toggleState, setToggleState] = useState(1);
  // const toggleTab = (index) => {
  //   setToggleState(index);
  // }

  // const handleClick = () => setClick(!click);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch])
  console.log(currentUser);
  return (
    <Fragment>
        <div className="profile_main">
        <div className="profile_wrap">
          <div className="profile_img_wrap">
              <div className="profile_img_box">
                <img />
              </div>
          </div>
          <div className="profile_content_wrap">
            <span className="round_bg_ele"></span>
          <div className="profile_card_content profile_name">
              <span>Kamal Biswal</span>
            </div>
            <span className="profile_card_content">kkbiswal06@gmail.com</span>
            <span className="profile_card_content">8144659716</span>
            <span className="profile_card_content">06.08.2023</span>
          </div>
        </div>
        </div>
      
      
    </Fragment>
  );
}


export default UserProfile;